//------------------------------------------------------------------------------------

// const baseUrl = 'https://admin.backend.bslcatgvid.in';
// export const userBaseUrl = 'https://user.backend.bslcatgvid.in';

// https://abackend.bslcatgvid.in/



// for local dev run*******************
// const baseUrl = 'http://localhost:1001';
// export const userBaseUrl = 'http://localhost:1000';

// for produnction*******************
const baseUrl = 'https://abackend.bslcatgvid.in';
export const userBaseUrl = 'https://ubackend.bslcatgvid.in';



export default baseUrl;

//------------------------------------------------------------------------------------
